import { Button, Col, Row, Card, Container } from "react-bootstrap";

export default function BatchClassDetails({batchData}) {

    return (
        <Col xxl={4}>
            <Card className="shadow">
                <Card.Body className="d-flex flex-column p-2">
                    <Card.Title className="d-flex justify-content-between">
                        <span className="fw-bolder">Class Details</span>
                    </Card.Title>

                    <Card.Text>
                        <div>
                            <span className="text-primary fw-bold me-2">
                                Class:{" "}
                            </span>
                            {batchData?.name ?? "N/A"}
                        </div>
                        <div>
                            <span className="text-primary fw-bold me-2">
                                Test Date:{" "}
                            </span>
                            {batchData?.test_date ?? "N/A"}
                        </div>
                        <div>
                            <span className="text-primary fw-bold me-2">
                                Training Venue:{" "}
                            </span>
                            {batchData?.training_venue ?? "N/A"}
                        </div>
                        <div>
                            <span className="text-primary fw-bold me-2">
                                Test Venue:{" "}
                            </span>
                            {batchData?.test_venue ?? "N/A"}
                        </div>
                        <div>
                            <span className="text-primary fw-bold me-2">
                                Trade:{" "}
                            </span>
                            {batchData?.trade_category ?? "N/A"}
                        </div>
                    </Card.Text>
                </Card.Body>
            </Card>
        </Col>
    );
}
